import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, Button, FormControl, Select, MenuItem, IconButton, Typography } from '@material-ui/core';
import UnavailableIcon from '@material-ui/icons/RemoveCircle';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-root': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    padding: theme.spacing(2),
    margin: theme.spacing(1),
    alignItems: 'center',
  },
  button: {
    width: '50%',
    margin: '8px',
    backgroundColor: '#0288d1',
  },
  selectEmpty: {
    marginTop: theme.spacing(1),
  },
  btnDiv: {
    display: 'flex',
    padding: theme.spacing(2),
    width: '90%',
    justifyContent: 'center',
  },
}));

export default function UnavailableDialog(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [age, setAge] = React.useState('');

  const absenseReasons = props.settings;
  const [selected, setSelected] = useState('');
  //window.absenseReasons = absenseReasons;
  // useEffect(()=>{

  //         //setReason([...absenseReasons]);
  //         //console.log("Group Set in UseEffect");
  // },[props.open]);

  const handleClose = () => {
    //console.log(selected);
    props.onClose(selected);
  };

  const handleChange = (event) => {
    setSelected(event.target.value);
    //console.log(isChecked);
    //onClose(value);
  };

  return (
    <Dialog onClose={() => handleClose()} aria-labelledby='dialog-title' open={props.open} fullWidth maxWidth='xs' className={classes.root}>
      <DialogTitle id='dialog-title' style={{ textAlign: 'center' }}>
        <IconButton>
          <UnavailableIcon fontSize='large' style={{ color: '#0288d1' }} />
        </IconButton>
        <Typography variant='h5' style={{ color: '#0288d1' }}>
          {t('absencereasons.availability')}
        </Typography>
      </DialogTitle>
      <FormControl variant='outlined' className={classes.formControl}>
        <Select style={{ width: '90%' }} labelId='absense-reason' id='absensereason' value={selected} onChange={handleChange} label='AbsenseReason'>
          <MenuItem value=''>
            <em>None</em>
          </MenuItem>
          {absenseReasons.map((item) => (
            <MenuItem value={item}>{item}</MenuItem>
          ))}
        </Select>
        <div className={classes.btnDiv}>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              props.onClose(selected);
            }}
            className={classes.button}>
            {t('absencereasons.set')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              props.onClose('');
            }}
            className={classes.button}>
            {t('absencereasons.cancel')}
          </Button>
        </div>
      </FormControl>
    </Dialog>
  );
}
